"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileAppToJSON = exports.MobileAppFromJSONTyped = exports.MobileAppFromJSON = exports.instanceOfMobileApp = exports.MobileAppAdTypeEnum = exports.MobileAppPlatformEnum = void 0;
var runtime_1 = require("../runtime");
var MobileMeasurementPartner_1 = require("./MobileMeasurementPartner");
/**
 * @export
 */
exports.MobileAppPlatformEnum = {
    Ios: 'IOS',
    Android: 'ANDROID'
};
/**
 * @export
 */
exports.MobileAppAdTypeEnum = {
    ViewThrough: 'VIEW_THROUGH',
    StoreKit: 'STORE_KIT'
};
/**
 * Check if a given object implements the MobileApp interface.
 */
function instanceOfMobileApp(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
exports.instanceOfMobileApp = instanceOfMobileApp;
function MobileAppFromJSON(json) {
    return MobileAppFromJSONTyped(json, false);
}
exports.MobileAppFromJSON = MobileAppFromJSON;
function MobileAppFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'platformAppId': !(0, runtime_1.exists)(json, 'platform_app_id') ? undefined : json['platform_app_id'],
        'platform': !(0, runtime_1.exists)(json, 'platform') ? undefined : json['platform'],
        'adType': !(0, runtime_1.exists)(json, 'ad_type') ? undefined : json['ad_type'],
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'iosAppId': !(0, runtime_1.exists)(json, 'ios_app_id') ? undefined : json['ios_app_id'],
        'androidAppUrl': !(0, runtime_1.exists)(json, 'android_app_url') ? undefined : json['android_app_url'],
        'mobileMeasurementPartner': !(0, runtime_1.exists)(json, 'mobile_measurement_partner') ? undefined : (0, MobileMeasurementPartner_1.MobileMeasurementPartnerFromJSON)(json['mobile_measurement_partner']),
        'datasetId': !(0, runtime_1.exists)(json, 'dataset_id') ? undefined : json['dataset_id'],
        'integrationId': !(0, runtime_1.exists)(json, 'integration_id') ? undefined : json['integration_id'],
    };
}
exports.MobileAppFromJSONTyped = MobileAppFromJSONTyped;
function MobileAppToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'platform_app_id': value.platformAppId,
        'platform': value.platform,
        'ad_type': value.adType,
        'id': value.id,
        'ios_app_id': value.iosAppId,
        'android_app_url': value.androidAppUrl,
        'mobile_measurement_partner': (0, MobileMeasurementPartner_1.MobileMeasurementPartnerToJSON)(value.mobileMeasurementPartner),
        'dataset_id': value.datasetId,
        'integration_id': value.integrationId,
    };
}
exports.MobileAppToJSON = MobileAppToJSON;
